import { useRecord, useRecords } from "@latticexyz/stash/react";
import mudConfig from "contracts/mud.config";
import { stash } from "../mud/stash";

import { formatMultilineForDisplay } from "../utils";

import "../assets/styles/seed-viewer.css";

export const SeedViewer = ( {seedId} ) => {


  const seed = useRecord({
    stash, 
    table: mudConfig.tables.StorySeed,
    key: { counterValue: seedId } 
  });
 
  return <>
    <div className="seed-viewer">
      <h1 className="seed-number">
        Chronicle {seed.seed}:
      </h1>
      <div className="seed-content">
        {(seed.data.length <= 0) ? '    ' : formatMultilineForDisplay(seed.data)}
      </div>
    </div>
  </>
}